export const buildLocizeOptions = (config = Config) => ({
    projectId: config.locizeProjectId,
    apiKey: config.locizeApiKey, // YOU should not expose your apps API key to production!!!
    referenceLng: 'en',
    version: 'latest',
    // version: Config.releaseStage === 'production' ? 'production' : 'latest'
    // i18next-locize-backend v9 defaults to standard/api.lite; this project uses pro/api.
    cdnType: config.locizeCdnType || 'pro'
});
